module.exports = {
    TOOLTIP_TEXT: {
        LOT_DIMENSIONS: `The length and width of each side of the lot. For condos, this will be "COMMON."`,
        SQUARE_FOOTAGE: `Note: In suburban markets, it's common for listings to include the assessed square footage from the county, which usually excludes basements. In Chicago, it's common for basements to be included in square footage estimates, which are based on the property's dimensions.`,
        LAUNDRY_FEATURES: `Hint: if this info is Unknown, try looking under Interior Features`,
        CHALLENGE_FRIEND: `Get 1 bonus guess for each player you best`
    },
};
